import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ForgotPasswordPage } from './forgot-password.page';

@NgModule({
  imports: [IonicModule, CommonModule, FormsModule],
  declarations: [ForgotPasswordPage]
})
export class ForgotPasswordPageModule {}
